import { Entity } from 'src/app/modules/portfolio/models/entity';
import { UpdateEntityRequest } from 'src/app/web-api-client';

export const mapEntityToUpdateRequest = (
  entity: Entity
): UpdateEntityRequest => {
  return new UpdateEntityRequest({
    entityId: entity?.entityId ?? 0,
    clientId: entity.clientId,
    residencyJurisdictionId:
      entity.residencyJurisdiction?.residencyJurisdictionId,
    entityTypeId: entity.entityType?.entityTypeId,
    name: entity.name ?? '',
    description: entity.description ?? '',
    isActive: entity.isActive ?? true,
  });
};
